<template>
  <div class="noFeedback">
    <div v-for="(item,index) in feedbackNoInfoList" :key="index" class="bg-FF p-24 m-t-20  feedbackReceivedList ">
        <div  class="m-b-24 feedbackReceivedListName flex row-left">
            <img src="@/assets/icon/feedbackStatistics/user.png" alt="人员" class="w-40 h-42 m-r-16">
            <div class="userName font-32 text-left">{{ item.nickName }}</div>
            <!-- <van-icon name="arrow"  class="m-r-0 font-32" @click="jumpDetail(item)"/> -->
        </div>
        <div class="cor-99 flex font-28 row-between">
            <div class="flex row-between m-b-16 itemBoxBg p-8 b-r-10  w-280 m-r-16">
                <div class="w-38 h-40 m-r-8">
                    <img src="@/assets/icon/feedbackStatistics/attendanceRecordIcon.png" alt="人员" class="width-100 height-100">
                </div>
                正常考勤:
                <span class="cor-66">{{ item.kqNum }}天</span>
            </div>
            <div class="flex row-between m-b-16 itemBoxBg p-8  b-r-10 flex-1">
                <div class="w-38 h-40 m-r-8">
                    <img src="@/assets/icon/feedbackStatistics/noFeedbackIcon.png" alt="人员" class="width-100 height-100">
                </div>
                未反馈:
                <span class="cor-66">{{ item.notFeedbackNum }}(请假{{item.leaveDays}}天)</span>
            </div>
            
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'feedbackReceived',
  props: {
    feedbackNoInfoList: {
      type: Array,
      default: () => {[]},
    },
  },

  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
  },
  methods: {

    //跳转详情
    jumpDetail(item){
      console.log(item)
      console.log(this.$store.state.user)
      this.$router.push({path: '/feedbackReceivedView', query: {id: item.id}})
    }
  }
}
</script>
<style lang="less" scoped>
.noFeedback{
    .userName{
         width: calc(100% - 40px - 16px - 32px);
    }
    .itemBoxBg{
        background: #F6F8FA;
    }
}
</style>
